export default "__VITE_ASSET__D4xMFLT9__"